import * as React from "react";
import * as Yup from 'yup';
import { Formik, Form } from 'formik';
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import CustomSelect from "../CustomComponents/CustomSelect";
import moment from "moment";
import { dateTransformation } from '../../utils.js'
import { makeStyles } from "@mui/styles";
import {checkAuthentication} from '../../utils';

export default function EditSowAmendmentDialog({ handleEditAmendmentCallback, data }) {
    const [refresh, setRefresh] = React.useState(true);
    const [open, setOpen] = React.useState(false);
    const currencyRegEx = /^(?!0\d)((?:\d{1,2})|(?:\d{1,2}(?:\.\d{1,2})))$/;
	const [LockedAlert, setAlert] = React.useState(false);
    const [sowChoices, setSowChoices] = React.useState([]);
    
    /*const useStyles = makeStyles((theme) => ({
	  root: {
	    '& .MuiInputBase-root': {
	     	backgroundColor: "#FFFFFF",
            padding: '5px 10px 5px',
            height: '100px',
            
	    },
	  },
	}));
	
	const classes = useStyles();*/

    const initialValues = {
        MGPT: data.MGPT,
        Name: data.CommonName,
        SOW: data.SOWID,
        weekDayOT: data.OverTimeWeek,
        weekEndOT: data.OverTimeWeekEnd,
        holidayOT: data.OverTimeHoliday,
        start: moment.utc(data.StartDate).format("MM/DD/YYYY"),
        end: moment.utc(data.EndDate).format("MM/DD/YYYY"),
        sharepointLink: data.Link,
        Comment: data.Comment,
        AmendmentDate: moment.utc(data.AmendmentDate).format("MM/DD/YYYY")
    };

    const validFormSchema = Yup.object({
        MGPT: Yup
            .string('Enter a MGPT number for this SOW')
            .required('MGPT is required'),
        Name: Yup
            .string('Enter a short name for this SOW')
            .required('Short Name is required'),
        SOW: Yup
            .string('Enter a SOW to attach this Amendment to ')
            .required('Linked PO is required'),
        weekDayOT: Yup
            .string('Enter Week Day OT rate')
            .matches(currencyRegEx, "Please enter a correct dollar amount")
            .required('Week Day OT rate required'),
        weekEndOT: Yup
            .string('Enter Weekend OT rate')
            .matches(currencyRegEx, "Please enter a correct dollar amount")
            .required('Weekend OT rate required'),
        holidayOT: Yup
            .string('Enter Holiday OT rate')
            .matches(currencyRegEx, "Please enter a correct dollar amount")
            .required('Holiday OT rate required'),
        sharepointLink: Yup
            .string('Enter a sharepoint link to this SOW')
            .required('Sharepoint link is required'),
        start: Yup
            .date('Enter start date of SOW. mm/dd/yyyy')
            .required('Start date required. mm/dd/yyyy'),
        end: Yup
            .date('Enter end date of SOW. mm/dd/yyyy')
            .required('End date required. mm/dd/yyyy'),
        AmendmentDate: Yup
            .date('Enter start date of SOW. mm/dd/yyyy')
            .required('Start date required. mm/dd/yyyy')
    })

    const onTrigger = React.useCallback((values) => {
        const msg = {
            MGPT: values.MGPT,
            CommonName: values.Name,
            SOWID: values.SOW,
            Comment: values.Comment,
            OverTimeWeek: parseFloat(values.weekDayOT),
            OverTimeWeekEnd: parseFloat(values.weekEndOT),
            OverTimeHoliday: parseFloat(values.holidayOT),
            Link: values.sharepointLink,
            StartDate: moment.utc(values.start),
            EndDate: moment.utc(values.end),
            AmendmentDate: moment.utc(values.AmendmentDate),
            ID: data.ID
        };
		if( ( moment.utc(values.start)>moment.utc(values.end))){
					setAlert(true);
				} else {
        handleEditAmendmentCallback(msg);
        handleClose();
        }
    })

	const handleAlertClose = () => {
	        setAlert(false);
	    };
	    
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const setChoices = (json) => {
        let choices = [];
        json.forEach(choice => choices.push({ label: choice.CommonName, value: choice.ID }))
        setSowChoices(choices)
    }

    React.useEffect(() => {
		if (open){
		checkAuthentication();
		}
        if (refresh) {
            fetch('api/SOW', {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => setChoices(json))

            setRefresh(false);
        }
    })

    return (
        <div>
            <Button variant="contained" onClick={handleClickOpen}>
                Edit
            </Button>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="lg">

                <DialogContent>
                    <Formik
                        initialValues={initialValues}
                        validationSchema={validFormSchema}
                        onSubmit={(values, { resetForm }) => {
                            onTrigger(values);
                            resetForm();
                        }}
                    >
                        {props => (
                            <Form>
                                <AppBar sx={{ position: 'relative' }}>
                                    <Toolbar>
                                        <IconButton
                                            edge="start"
                                            color="inherit"
                                            onClick={handleClose}
                                            aria-label="close"
                                        >
                                            <CloseIcon />
                                        </IconButton>
                                        <Typography sx={{ ml: 2, flex: 1, color:"white" }} variant="h6" component="div" >
                                            Amendment
                                        </Typography>
                                       <Button autoFocus color="inherit" onClick={props.handleSubmit}>
                                            save
                                        </Button>
                                    </Toolbar>
                                </AppBar>
                                <DialogTitle>SOW Amendment Edit:</DialogTitle>
                                <div>
                                    <FormControl sx={{ m: 1, width: 220 }}>
                                        <TextField
                                            name="MGPT"
                                            variant="outlined"
                                            id="outlined-MGPT"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.MGPT}
                                            error={props.touched.MGPT && Boolean(props.errors.MGPT)}
                                            helperText={props.touched.MGPT && props.errors.MGPT}
                                            label="MGPT"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 400 }}>
                                        <TextField
                                            name="Name"
                                            variant="outlined"
                                            id="outlined-ShortName"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.Name}
                                            error={props.touched.Name && Boolean(props.errors.Name)}
                                            helperText={props.touched.Name && props.errors.Name}
                                            label="Name"
                                        />
                                    </FormControl>
                                    <FormControl sx={{ m: 1, width: 200 }}>
                                        <InputLabel htmlFor="outlined-Name">SOW</InputLabel>
                                        <CustomSelect
                                            name="SOW"
                                            id="outlined-SOWID"
                                            options={sowChoices}
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.SOW}
                                            error={props.touched.SOW && Boolean(props.errors.SOW)}
                                            helperText={props.touched.SOW && props.errors.SOW}
                                            label="SOW"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 210 }}>
                                        <TextField
                                            name="weekDayOT"
                                            id="outlined-weekDayOT"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.weekDayOT}
                                            error={props.touched.weekDayOT && Boolean(props.errors.weekDayOT)}
                                            helperText={props.touched.weekDayOT && props.errors.weekDayOT}
                                            label="Weekday Overtime Rate"
                                        />
                                    </FormControl>

                                    <FormControl sx={{ m: 1, width: 210 }}>
                                        <TextField
                                            name="weekEndOT"
                                            id="outlined-weekEndOT"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.weekEndOT}
                                            error={props.touched.weekEndOT && Boolean(props.errors.weekEndOT)}
                                            helperText={props.touched.weekEndOT && props.errors.weekEndOT}
                                            label="WeekEnd Overtime Rate"
                                        />
                                    </FormControl>

                                    <FormControl fullWidth sx={{ m: 1, width: 210 }}>
                                        <TextField
                                            name="holidayOT"
                                            id="outlined-holidayOT"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.holidayOT}
                                            error={props.touched.holidayOT && Boolean(props.errors.holidayOT)}
                                            helperText={props.touched.holidayOT && props.errors.holidayOT}
                                            label="Holiday Overtime Rate"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 180 }}>
                                        <TextField
                                            name="start"
                                            id="outlined-start"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.start.indexOf("/")>0?dateTransformation(props.values.start):props.values.start}
                                            error={props.touched.start && Boolean(props.errors.start)}
                                            helperText={props.touched.start && props.errors.start}
                                            label="Start Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>

                                    <FormControl sx={{ m: 1, width: 180 }}>
                                        <TextField
                                            name="end"
                                            id="outlined-end"
                                            type="date"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.end.indexOf("/")>0?dateTransformation(props.values.end):props.values.end}
                                            error={props.touched.end && Boolean(props.errors.end)}
                                            helperText={props.touched.end && props.errors.end}
                                            label="End Date"
                                            InputLabelProps={{
												shrink: true,
											}}
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1, width: 240 }}>
                                        <TextField
                                            name="sharepointLink"
                                            id="outlined-sharepointLink"
                                            onChange={props.handleChange}
                                            onBlur={props.handleBlur}
                                            value={props.values.sharepointLink}
                                            error={props.touched.sharepointLink && Boolean(props.errors.sharepointLink)}
                                            helperText={props.touched.sharepointLink && props.errors.sharepointLink}
                                            label="SharePoint Link"
                                        />
                                    </FormControl>
                                </div>
                                <div>
                                    <FormControl sx={{ m: 1}}>
                                        <TextField
                                            name="Comment"
                                            id="outlined-Comment"
                                            label="Comment"
                                            multiline
                                            rows={4}
                                            value={props.values.Comment}
                                            onChange={props.handleChange}
                                        />
                                    </FormControl>
                                </div>
                                <FormControl sx={{ m: 1, width: 180 }}>
                                    <TextField
                                        name="AmendmentDate"
                                        id="outlined-end"
                                        onChange={props.handleChange}
                                        onBlur={props.handleBlur}
                                        value={props.values.AmendmentDate}
                                        error={props.touched.AmendmentDate && Boolean(props.errors.AmendmentDate)}
                                        helperText={props.touched.AmendmentDate && props.errors.AmendmentDate}
                                        label="Amendment Date"
                                    />
                                </FormControl>
                            </Form>
                        )}
                    </Formik>
                </DialogContent>
                <Dialog
                    open={LockedAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="Date Alert"
                    aria-describedby="Start Date before the End Date"
                >
                    <DialogTitle id="Date Alert">
                        {"Alert"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {"Start Date should be before the End Date, Please enter different time period"}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={() => { setAlert(false) }} autoFocus>Close</Button>
                    </DialogActions>
                </Dialog>       
            </Dialog>
        </div>
    );
}